import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'intro.component.html', selector: 'intro' })
export class IntroComponent {
    
    loading = false;
    introId:any;
    intro:any;
    theme:any;

    constructor(private route: ActivatedRoute, private courseService: CourseService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.introId = params.get('id');
            this.getIntro();
        })
    }

    getIntro() {
        this.courseService.getSection(this.introId).pipe(first()).subscribe(data => {
            this.loading = false;
            this.intro = data.section;
            this.theme = data.theme.toLowerCase();
        });
    }

    save() {
        return this.courseService.addProgress(this.introId);
    }
}